import {Injectable, NgModule} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HTTP_INTERCEPTORS} from "@angular/common/http";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let token = sessionStorage.getItem('accessToken');

        if (req.method === 'POST' || req.method === 'PUT')
            this.removeTimezone(req.body);

        if (token) {
            const newReq = req.clone(
                {
                    headers: req.headers.set('Authorization', `Bearer ${token}`)
                });

            return next.handle(newReq);
        } else {
            return next.handle(req);
        }
    }

    removeTimezone(body) {
        if (body === null || body === undefined) {
            return body;
        }

        if (typeof body !== 'object') {
            return body;
        }

        for (const key of Object.keys(body)) {
            const value = body[key];
            if (value instanceof Date) {
                body[key] = new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes()
                    , value.getSeconds()));
            } else if (typeof value === 'object') {
                this.removeTimezone(value);
            }
        }
    }
}

@NgModule({
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestInterceptor,
            multi: true
        }
    ]
})

export class HttpRequestInterceptorModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/http-request-interceptor.ts